'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Info = require('./Info');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Info).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Info/index.js
// module id = 1210
// module chunks = 1